export const PROJECTS_ROUTE_SEGMENT = 'projects';
export const ARCHIVE_ROUTE_SEGMENT = 'archive';
